import { IDataProviderFilter, IFilter } from 'core-components/types'

export const getFilterFields = (filter: IFilter | IDataProviderFilter | undefined | void) => {
  let filterFields: string[] = []

  if (!filter) {
    return filterFields
  }

  if ((filter as IFilter).hasOwnProperty('field')) {
    filterFields.push((filter as IFilter).field)
  }

  const typedFilter = filter as IDataProviderFilter
  if (typedFilter.hasOwnProperty('filters')) {
    typedFilter.filters.forEach((f) => {
      const foundNestedFilterFields = getFilterFields(f)
      if (foundNestedFilterFields && foundNestedFilterFields.length > 0) {
        filterFields = [...filterFields, ...foundNestedFilterFields]
      }
    })
  }
  return filterFields
}
